

import { Enums } from '@bode-canada/core';

export default {
  name: 'MarketDaysComponent',
  props: {
    listing: {
      default: () => ({}),
      type: Object,
    },
  },
  computed: {
    daysOnMarket() {
      return this.listing.daysOnMarket;
    },
    daysLabel() {
      const isDaysOnSystem = this.listing.origin === Enums.ListingOriginEnum.REPLIERS_RAE
        && this.listing.status === Enums.ListingStatusEnum.ACTIVE;

      return isDaysOnSystem ? 'Days On System' : 'Days On Market';
    },
  },
};
